import Vue from "vue";
import moment from "moment";
import VueMoment from "vue-moment";
import "moment/locale/ru";
import moment_timezone from "moment-timezone";

Vue.use(VueMoment, {
  moment,
  moment_timezone,
});
